import { ApiBind, CommonSearchParam } from './common-search-param.model';

export class SDKVersionSearchParam extends CommonSearchParam {

  constructor(
    value?: string
  ) {
    super();
    this.value = value;
  }

  @ApiBind({ column: 'value' })
  value: string;

}
